











































































































import Vue from "vue";
import { Advertiser } from "../../../interfaces/advertiser";
import { mapState } from "vuex";
import _ from "lodash";
import Api from "@/api/Api";
export default Vue.extend({
  methods: {
    async confirm() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.updateAdvertiser)) {
        if (_.isPlainObject(v) && (v as any)["@id"]) {
          postData[k] = (v as any)["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        await Api.singleton().call({
          method: "POST",
          resource: this.updateAdvertiser["@id"] + "/validate",
          body: decorated
        });
        this.phase = "confirm";
      } catch (violations) {
        if (violations instanceof Array) {
          for (const v of violations) {
            this.$set(this.errors, v.propertyPath, v.message);
          }
        }
      }
      this.isLoading = false;
    },
    async exec() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.updateAdvertiser)) {
        if (_.isPlainObject(v) && (v as any)["@id"]) {
          postData[k] = (v as any)["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        const ret = (await Api.singleton().call({
          method: "PATCH",
          resource: this.updateAdvertiser["@id"],
          body: decorated
        })) as object & { id: string };
        this.phase = "confirm";
        this.$router.push({
          name: "AdministratorAdvertisersComplete"
        });
      } catch (violations) {
        alert("登録時にエラーが発生しました");
      }
      this.isLoading = false;
    },
    async decoratePostData(postData: Record<string, unknown>) {
      delete postData.advertisements;
      return postData;
    },
    async loadAdvertiser() {
      this.updateAdvertiser = await this.$store.dispatch(
        "loadResource",
        "/api/adv/clients/" + this.$route.params.id
      );
      this.isLoading = false;
    }
  },
  async mounted() {
    await this.$store.dispatch("fetchPrefectures");
    this.loadAdvertiser();
  },
  computed: {
    ...mapState(["prefectures"])
  },
  data() {
    return {
      isLoading: true,
      phase: "input",
      updateAdvertiser: {} as Partial<Advertiser>,
      errors: {}
    };
  }
});
